import React from 'react';

const EmailPagination = ({
  currentPage,
  totalPages,
  totalEmails,
  emailsPerPage,
  onPageChange
}) => {
  if (totalPages <= 1) return null;

  const startIndex = ((currentPage - 1) * emailsPerPage) + 1;
  const endIndex = Math.min(currentPage * emailsPerPage, totalEmails);

  return (
    <div className="flex items-center justify-between px-6 py-3 border-t border-gray-400/20 bg-gray-900/50">
      <div className="text-sm text-gray-400">
        Showing {startIndex}-{endIndex} of {totalEmails} emails
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className={`px-2 py-1 rounded text-sm ${
            currentPage === 1 
              ? 'text-gray-600 cursor-not-allowed' 
              : 'text-gray-400 hover:bg-gray-800'
          }`}
        >
          First
        </button>
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className={`px-3 py-1 rounded text-sm ${
            currentPage === 1 
              ? 'text-gray-600 cursor-not-allowed' 
              : 'text-gray-400 hover:bg-gray-800'
          }`}
        >
          ← Prev
        </button>
        <span className="px-3 py-1 bg-gray-800 rounded text-sm text-white">
          {currentPage} / {totalPages}
        </span>
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 rounded text-sm ${
            currentPage === totalPages 
              ? 'text-gray-600 cursor-not-allowed' 
              : 'text-gray-400 hover:bg-gray-800'
          }`}
        >
          Next →
        </button>
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className={`px-2 py-1 rounded text-sm ${
            currentPage === totalPages 
              ? 'text-gray-600 cursor-not-allowed' 
              : 'text-gray-400 hover:bg-gray-800'
          }`}
        >
          Last
        </button>
      </div>
    </div>
  );
};

export default EmailPagination;
